import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router';

import { rutaExportarObservacions } from '../../routes/routeConstants';

const ObservacioBotoExportacio = () => {
    return (
        <Link className='observacio-boto-exportacio' to={rutaExportarObservacions}>
            <Button icon='export'>
                Exportació
            </Button>
        </Link>
    );
};

export default ObservacioBotoExportacio;



// WEBPACK FOOTER //
// ./src/components/observacio/observacioBotoExportacio.js